import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { ResidentialCalculator } from '../Calculators'

import { unitedNumber } from '../propTypes'
import * as info from './info'

import CalculationGroup from '../Widgets/CalculationGroup'

export default class BuildingAndMarketingCost extends Component {
  static propTypes = {
    calculator: PropTypes.instanceOf(ResidentialCalculator).isRequired,
    data: PropTypes.shape({
      baseBuildCost: PropTypes.number,
      developmentContingency: unitedNumber,
      constructionAbnormals: PropTypes.number,
      externals: unitedNumber,
      professionalFees: unitedNumber,
      salesAndMarketing: unitedNumber,
      legalFeesPerUnit: PropTypes.number,
      finance: unitedNumber,
    }).isRequired,
    readOnly: PropTypes.bool,
    updateField: PropTypes.func,
  }

  handleFieldChangedFactory = (field) => (value) => this.props.updateField(field, value)

  render() {
    const { calculator, data, readOnly } = this.props

    return (
      <Fragment>
        <h2>Building and Marketing Cost</h2>

        <CalculationGroup
          readOnly={readOnly}
          field='baseBuildCost'
          info={info.baseBuildCost}
          label='Build costs'
          value={data.baseBuildCost}
          onChange={readOnly ? null : this.handleFieldChangedFactory('baseBuildCost')}
          average={calculator.getAverage(calculator.getBaseBuildCostTotal())}
          total={calculator.getBaseBuildCostTotal()}
          input={{
            allowZero: true,
            autoFocus: true,
            prefix: '£',
            suffix: calculator.getPerUnitAreaLabel(),
          }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='developmentContingency'
          info={info.developmentContingency}
          label='Development contingency'
          value={data.developmentContingency.value}
          unit={data.developmentContingency.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('developmentContingency')}
          average={calculator.getAverage(calculator.getDevelopmentContingencyTotal())}
          total={calculator.getDevelopmentContingencyTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='constructionAbnormals'
          info={info.constructionAbnormals}
          label='Construction abnormals'
          value={data.constructionAbnormals}
          onChange={readOnly ? null : this.handleFieldChangedFactory('constructionAbnormals')}
          average={calculator.getAverage(calculator.getConstructionAbnormalsTotal())}
          total={calculator.getConstructionAbnormalsTotal()}
          input={{ allowZero: true, prefix: '£' }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='externals'
          info={info.externals}
          label='Externals'
          value={data.externals.value}
          unit={data.externals.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('externals')}
          average={calculator.getAverage(calculator.getExternalsTotal())}
          total={calculator.getExternalsTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='professionalFees'
          info={info.professionalFees}
          label='Professional fees'
          value={data.professionalFees.value}
          unit={data.professionalFees.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('professionalFees')}
          average={calculator.getAverage(calculator.getProfessionalFeesTotal())}
          total={calculator.getProfessionalFeesTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='salesAndMarketing'
          info={info.salesAndMarketing}
          label='Sales & marketing'
          value={data.salesAndMarketing.value}
          unit={data.salesAndMarketing.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('salesAndMarketing')}
          average={calculator.getAverage(calculator.getSalesAndMarketingTotal())}
          total={calculator.getSalesAndMarketingTotal()}
          input={{ allowZero: true }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='legalFeesPerUnit'
          info={info.legalFeesPerUnit}
          label='Legal fees'
          value={data.legalFeesPerUnit}
          onChange={readOnly ? null : this.handleFieldChangedFactory('legalFeesPerUnit')}
          total={calculator.getLegalFeesTotal()}
          input={{ allowZero: true, suffix: 'per unit' }}
        />
        <CalculationGroup
          readOnly={readOnly}
          field='finance'
          info={info.finance}
          label='Finance'
          value={data.finance.value}
          unit={data.finance.unit}
          unitType='percent-fixed'
          onChange={readOnly ? null : this.handleFieldChangedFactory('finance')}
          average={calculator.getAverage(calculator.getFinanceTotal())}
          total={calculator.getFinanceTotal()}
          input={{ allowZero: true }}
        />
      </Fragment>
    )
  }
}
